import React from 'react';
import {Container} from 'react-bootstrap'

const AuthWrapper = ({ headline, children }) => {
  return (
    <div className="main">
		<section className="text-center">
			<Container >
				{headline && <h1>{headline}</h1>}

				<div className="children">
					{children && children}
				</div>
			</Container>
		</section>
    </div>
  );
}

export default AuthWrapper;